module.exports = __webpack_public_path__ + "static/media/prince.217044a7.gif";